
export default {
  list: []
}



// WEBPACK FOOTER //
// ./src/features/admin/perfis/store/state.js